import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-data-deletion',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './data-deletion.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../terms/terms.scss'],
})
export class DataDeletion {}
